/**
 * Sets up validation for operands when the operator is division.
 */
export function setupOperandValidation(firstNumberDifficultySelector, secondNumberDifficultySelector, operatorSelector) {
	function validateOperands() {
		// Enable all second operand options by default
		for (let option of secondNumberDifficultySelector.options) {
			option.disabled = false;
		}

		// If the operator is division, disable second operand options greater than the first
		if (operatorSelector.value === 'division') {
			for (let option of secondNumberDifficultySelector.options) {
				if (parseInt(option.value) > parseInt(firstNumberDifficultySelector.value)) {
					option.disabled = true;
				}
			}
			// If the current selected second operand is greater than the first operand, change it
			if (parseInt(secondNumberDifficultySelector.value) > parseInt(firstNumberDifficultySelector.value)) {
				secondNumberDifficultySelector.value = firstNumberDifficultySelector.value; // Set the second operand to the first operand value
			}
		}
	}

	// Add event listeners to detect changes in operands or operator
	firstNumberDifficultySelector.addEventListener('change', validateOperands);
	secondNumberDifficultySelector.addEventListener('change', validateOperands);
	operatorSelector.addEventListener('change', validateOperands);
}
